import { render, staticRenderFns } from "./PrinciplesPage.vue?vue&type=template&id=6cd4f9fb&scoped=true"
import script from "./PrinciplesPage.vue?vue&type=script&lang=js"
export * from "./PrinciplesPage.vue?vue&type=script&lang=js"
import style0 from "./PrinciplesPage.vue?vue&type=style&index=0&id=6cd4f9fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd4f9fb",
  null
  
)

export default component.exports